'use strict';

const urlJoin = require('url-join');
const config = require('../config');
const { default: stipulate, buildOptions, resolveUrl } = require('stipulate');

const { baseOptions } = require('./configuration');

const decline = () => {
    const { baseUrl } = config.get();

    const url = urlJoin(baseUrl, '/pb/users/me/decline-difm/');
    const requestOptions = buildOptions(baseOptions, {
        method: 'POST',
    });

    return stipulate(url, requestOptions, 'blob');
};

const remindLater = () => {
    const { baseUrl } = config.get();

    const url = urlJoin(baseUrl, '/pb/users/me/remind-later-of-difm/');
    const requestOptions = buildOptions(baseOptions, {
        method: 'POST',
    });

    return stipulate(url, requestOptions, 'blob');
};

const submit = (options, query) => {
    const { baseUrl } = config.get();

    if (!options.selected_package) {
        throw new Error('Expected `options.selected_package` to be set');
    }

    if (!options.price) {
        throw new Error('Expected `options.price` to be set');
    }

    let url = urlJoin(baseUrl, '/pb/users/me/submit-difm-request/');
    url = resolveUrl(url, query);

    const requestOptions = buildOptions(baseOptions, {
        method: 'POST',
        body: JSON.stringify(options),
    });

    return stipulate(url, requestOptions, 'blob');
};

const acceptDifmRequest = () => {
    const { baseUrl } = config.get();
    const url = urlJoin(baseUrl, '/pb/users/me/accept-difm-request/');
    const requestOptions = buildOptions(baseOptions, {
        method: 'POST',
    });
    
    return stipulate(url, requestOptions, 'blob');
}

module.exports = {
    acceptDifmRequest,
    decline,
    remindLater,
    submit,
};
